import React from 'react';
import { Phone, Shield, Heart, Pill, Home, Scale, Users, Stethoscope } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Benefits = () => {
  const benefits = [
    {
      icon: Stethoscope,
      title: 'Telemedicina',
      description: 'Atendimento 24h com especialistas (por agendamento)',
      details: 'Titular + 4 dependentes',
      color: 'emerald'
    },
    {
      icon: Shield,
      title: 'Indenização por Invalidez',
      description: 'Indenização de até R$ 10.000 por Invalidez Permanente Total ou Parcial',
      details: 'Válido a partir do 1º pagamento • Somente titular',
      color: 'emerald'
    },
    {
      icon: Heart,
      title: 'Indenização por Morte',
      description: 'Indenização de R$ 10.000 por Morte por Acidente',
      details: 'Válido a partir do 1º pagamento • Somente titular',
      color: 'emerald'
    },
    {
      icon: Pill,
      title: 'Desconto Farmácia',
      description: '10% a 70% de desconto em medicamentos',
      details: 'Pesquisa por medicamento e rede credenciada • Titular + 4 dependentes',
      color: 'emerald'
    },
    {
      icon: Users,
      title: 'Auxílio Funeral',
      description: 'Reembolso de até R$ 3.000 em despesas funerárias',
      details: 'Despesas comprovadas com NF (caixão, velório, cremação, traslado)',
      color: 'emerald'
    },
    {
      icon: Phone,
      title: 'Desconto Consultas e Exames',
      description: 'Consultas e exames com desconto em todo território nacional',
      details: 'Agendamento via app em até 48h • Somente titular',
      color: 'emerald'
    },
    {
      icon: Home,
      title: 'Assistência Residencial',
      description: 'Serviços emergenciais (Eletricista, Encanador, Chaveiro, Vidraceiro) e não emergenciais',
      details: 'Até R$ 300 com pré-autorização via Central',
      color: 'emerald'
    },
    {
      icon: Scale,
      title: 'Assistência Jurídica',
      description: 'Orientação Previdenciária, apoio jurídico e intermediação com órgãos públicos',
      details: 'Recurso junto ao INSS, Direito do Consumidor e mais',
      color: 'emerald'
    }
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Pacote de Benefícios Completo
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            8 benefícios essenciais para proteger você e sua família em todas as situações
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Card
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#00E5CC]/50 hover:-translate-y-2"
              >
                <CardContent className="p-8 space-y-4">
                  <div className="w-14 h-14 bg-[#00E5CC]/10 rounded-xl flex items-center justify-center group-hover:bg-[#00E5CC] transition-colors duration-300 border border-[#00E5CC]/30">
                    <Icon className="w-7 h-7 text-[#00E5CC] group-hover:text-white transition-colors duration-300" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900">
                    {benefit.title}
                  </h3>
                  
                  <p className="text-gray-700 leading-relaxed">
                    {benefit.description}
                  </p>
                  
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {benefit.details}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 bg-[#00E5CC]/10 rounded-2xl p-8 text-center border-2 border-[#00E5CC]/20">
          <p className="text-lg font-semibold text-gray-900 mb-2">
            Todos esses benefícios por apenas R$ 59,90/mês
          </p>
          <p className="text-gray-600">
            Proteção completa para você e até 4 dependentes em diversos benefícios
          </p>
        </div>
      </div>
    </section>
  );
};
